import React, { useState, useEffect, useCallback } from 'react';
import { PropTypes } from 'prop-types';
import { Row, Col, Card  } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Redirect } from "react-router-dom";
import ShopHOC from '../../hoc/ShopHOC';
import ProductList from './ProductList/ProductList';
import CategoryList from './CategoryList/CategoryList';
import OrderSelect from './OrderSelect/OrderSelect';
/* import SupportModal from '../Modals/SupportModal/SupportModal'; */

ShopContainer.propTypes = {
    eventID: PropTypes.string.isRequired
}

function ShopContainer(props) {
    const { t } = useTranslation();
    const { eventID, fetchOrders, fetchCart, orders, partnerPortalSettings, portalClosed, ordersLoading } = props;
    const { userCanEditOrders } = partnerPortalSettings;
    const [expandedKeys, setExpandedKeys] = useState([]);
    const [selectedKeys, setSelectedKeys] = useState([]);
    // lahti-salesforce-usecase
    const [selectedOrder, setSelectedOrder] = useState(localStorage.getItem('orderID'));
    const ordersAndProductsDisabledEvents = ['8973cebe-8916-11ea-a21a-ee6a04371b85']; // List of events that have orders and products disabled.

    useEffect(() => {
        fetchOrders();
    }, [fetchOrders]);

    const onSelectOrder = useCallback((orderID) => {
        setSelectedOrder(orderID);
        localStorage.setItem('orderID', orderID);
        fetchCart(eventID);
    }, [eventID, fetchCart]);

    /**
     * For salesforce/lahti, force set orderID, when order is "updated"
     * In saga, orderID is set to null (for non-lahti-cases)
     */
    /* useEffect(() => {
        if (userCanEditOrders) {
            if (!selectedOrder && orders.length) {
                    onSelectOrder(orders[0].orderID);
            }
        }
    }, [onSelectOrder, orders, selectedOrder, userCanEditOrders]); */

    const onExpand = (expandedKeys) => {
		setExpandedKeys(expandedKeys)
    };
    
    const onSelect = (selectedKeys) => {
        setSelectedKeys(selectedKeys)
    };

    if(ordersAndProductsDisabledEvents.includes(eventID)) {
        return <Redirect to={`/`} />
    }

    return (
        <React.Fragment>
            <Row>
                <Col md={4}>
                    {userCanEditOrders ? // lahti-salesforce-usecase
                        <>
                            <h3>{t('orders.selected_order')}</h3>
                            <Card>
                                <OrderSelect
                                    eventID={eventID}
                                    selectedOrder={selectedOrder}
                                    onSelectOrder={onSelectOrder}
                                    orders={orders}
                                    loading={ordersLoading}
                                />
                            </Card>
                        </>
                    : null}
                    <h3>{t('products.categories')}</h3>
                    <Card>
                        <Card.Header>
                            {t('products.browse_categories')}
                        </Card.Header>
                        <CategoryList
                            eventID={eventID}
                            expandedKeys={expandedKeys}
                            selectedKeys={selectedKeys}
                            onExpand={onExpand}
                            onSelect={onSelect}
                        />
                    </Card>
                </Col>
                <Col md={8}>
                    <h3>{t('products.products')}</h3>
                    <Card>
                        <Card.Header>
                            {t('products.browse_products')}
                        </Card.Header>
                        <ProductList
                            selectedKeys={selectedKeys}
                            eventID={eventID}
                            portalClosed={portalClosed}
                        />
                    </Card>
                </Col>
            </Row>

        </React.Fragment>
    )
}



export default ShopHOC(ShopContainer);